import Index from './pages/index'
import './App.css';
import './css/index.scss';

function App() {
  return (
    <div className="App">
      <Index />
    </div>
  );
}

export default App;
